module.exports = __webpack_public_path__ + "static/media/ganbgshift.9ede9c18.png";